const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/UncaughtErrorDialog/UncaughtErrorDialog.tsx';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import textMap from './translations';
import { dismissUncaughtErrorDialog } from '../../actions/uiActions';
import { Knopf } from '@cistec/common_web/components/Knopf/Knopf';
import * as React from 'react';
import { CommonStoreState } from '@cistec/common_web/reducers';
import Imm from 'immutable';

type Props = {};

export const UncaughtErrorDialog = (props: Props) => {
    const dispatch = useDispatch();
    const { formatMessage } = useIntl();

    const settings =
        useSelector((state: CommonStoreState) => state.ui.getIn(['general', 'uncaughtError'])) || Imm.fromJS({});

    const showError = settings.get('visible');
    const errorLocation = settings.get('location');
    const errorMessage = settings.get('message');
    const errorTextMapId = settings.get('textMapId');
    const errorStackTrace = settings.get('trace');

    if (!showError) {
        return null;
    }

    const isProduction = process.env.NODE_ENV === 'production';
    const canSeeLocation = errorLocation && !isProduction;

    const title: string = (() => {
        if (canSeeLocation) {
            return formatMessage(textMap.titleWithLocation, { location: errorLocation });
        } else {
            return formatMessage(textMap.titleWithoutLocation);
        }
    })();

    const actualMsg: string = (() => {
        const lines: string[] = [];

        if (errorTextMapId) {
            const entry = (textMap as any)[errorTextMapId];

            if (entry) {
                lines.push(formatMessage(entry));
            }
        }

        if (errorMessage) {
            lines.push(errorMessage);
        }

        if (!lines.length) {
            lines.push(formatMessage(textMap.unknownError));
        }

        return lines.join('\n');
    })();

    const closeDialog = () => {
        dispatch(dismissUncaughtErrorDialog());
    };

    return (
        <Dialog open={true} onClose={closeDialog} maxWidth={isProduction ? 'sm' : 'lg'}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{actualMsg}</DialogContentText>
                {!isProduction && errorStackTrace && <pre style={{ fontSize: 'smaller' }}>{errorStackTrace}</pre>}
            </DialogContent>
            <DialogActions>
                <Knopf text={textMap.closeButton} do={closeDialog} />
            </DialogActions>
        </Dialog>
    );
};
